import React from 'react';
import {graphql} from 'gatsby';

import {PageProps} from '../types';
import Layout from '../components/layout';
import Seo from '../components/seo';

const lang = 'en';

type Props = PageProps & NotFoundPageQueryResult;
function NotFoundPage({location, data}: Props) {
	const siteTitle = data.site.siteMetadata.siteTitle[lang];

	return (
		<Layout location={location} title={siteTitle} lang={lang}>
			<Seo title="404: Not Found" lang={lang} />
			<h1>Not Found</h1>
			<p>You just hit a route that doesn&#39;t exist... the sadness.</p>
		</Layout>
	);
}

export default NotFoundPage;

interface NotFoundPageQueryResult {
	data: {
		site: {
			siteMetadata: {
				siteTitle: {
					en: string;
				};
			};
		};
	};
}

export const pageQuery = graphql`
	query {
		site {
			siteMetadata {
				siteTitle {
					en
				}
			}
		}
	}
`;
